<template>
    <b-modal
        size="lg"
        v-model="mostrarModal"
        no-close-on-backdrop
        @close="fecharModal()"
        @show="preencher()">
        <div slot="modal-title">
            Despesa Parceiro -
            <b-badge variant="warning">{{ operacao }}</b-badge>
        </div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="6" md="6">
                <b-form-group>
                    <label class="required">Fonte do Recurso</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="fonteRecurso"
                            :disabled="true"
                            placeholder="PARCEIRO"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="6" md="6">
                <b-form-group>
                    <label class="required">Ação</label>
                    <b-input-group>
                        <b-form-select
                            v-model="acaoId"
                            type="text"
                            :options="acoes"
                            value-field="acaoId"
                            text-field="nomeAcao"
                        ></b-form-select>
                        <b-form-invalid-feedback>A Ação é obrigatória</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="12">
                <b-form-group>
                    <label class="required">Descritivo</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="descritivo"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="12">
                <b-form-group>
                    <label class="required">Proposta</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="proposta"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="3" md="3">
                <b-form-group>
                    <label class="required">Tipo do Recurso</label>
                    <b-input-group>
                        <b-form-select
                            type="text"
                            :options="tiposRecursos"
                            value-field="key"
                            text-field="label"
                            v-model="tipoRecurso"
                        ></b-form-select>
                        <b-form-invalid-feedback>O Tipo do Recurso é obrigatório</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="6" md="6">
                <b-form-group>
                    <label class="required">Natureza da Despesa</label>
                    <b-input-group>
                        <b-form-select
                            type="text"
                            :options="naturezas"
                            text-field="descricao"
                            value-field="codigo"
                            v-model="codigoNaturezaDespesa">
                        </b-form-select>
                        <b-form-invalid-feedback>A Natureza é obrigatória</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="3">
                <b-form-group>
                    <label class="required">Valor Total</label>
                    <b-input-group>
                        <b-form-input
                            type="number"
                            v-model="valorTotal"
                        ></b-form-input>
                        <b-form-invalid-feedback>O Valor é obrigatório</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                :disabled="this.$v.$invalid"
                @click.stop="salvar()"
                class="ml-1">
                Salvar
            </b-button>
        </div>
    </b-modal>
</template>

<script>

import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        pleito: Object,
        operacaoProp: String,
        mostrarModal: {
            type: Boolean,
            default: () => false
        },
        erros: {
            type: Array,
            default: () => []
        },
        dataServicos: {
            type: Object
        },
    },

    validations: {
        descritivo: {
            required
        },
        acaoId: {
            required
        },
        codigoNaturezaDespesa: {
            required
        },
        valorTotal: {
            required
        },
    },

    data() {
        return {
            acaoId:null,
            acoes: [],
            descritivo: '',
            fonteRecurso: 'PARCEIRO',
            proposta: '',
            tiposRecursos: [
                {
                    key: '1',
                    label: 'ECONÔMICO'
                },
                {
                    key: '2',
                    label: 'FINANCEIRO'
                },
            ],
            naturezas: [],
            codigoNaturezaDespesa: null,
            valorTotal: null,
            tipoRecurso: null,
        }
    },

    computed: {
        operacao() {
            if (this.operacaoProp == 'I') {
                return 'INCLUSÃO'
            }
            return 'ATUALIZAÇÃO'
        }
    },

    methods: {
        preencher() {
            this.obterAcoes(this.pleito.pleitoId)
            this.obterNaturezas()
            if (this.operacaoProp == 'A') {
                this.descritivo = this.despesaParceiro.descritivo
                this.acaoId = this.despesaParceiro.acaoId
                this.proposta = this.despesaParceiro.proposta
                this.codigoNaturezaDespesa = this.despesaParceiro.codigoNaturezaDespesa
                this.valorTotal = this.despesaParceiro.valorTotal
            }
        },

        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        resetar(){
            this.descritivo = ''
            this.acaoId = null
            this.proposta = ''
            this.codigoNaturezaDespesa = null
            this.valorTotal = null
            this.tipoRecurso = null
        },

        obterAcoes(pleitoId){
            this.$store.dispatch('addRequest')
            this.dataServicos.obterAcoes(pleitoId).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.acoes = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                    }
                )
        },

        obterNaturezas(){
            this.$store.dispatch('addRequest')
            this.dataServicos.obterNaturezas().then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.naturezas = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                    }
                )
        },

        salvar() {
            let despesaDto = {
                pleitoId : this.pleito.pleitoId,
                acaoId: this.acaoId,
                descritivo: this.descritivo,
                proposta: this.proposta,
                codigoNaturezaDespesa: this.codigoNaturezaDespesa,
                valorTotal: this.valorTotal,
                tipoRecurso: this.tipoRecurso,
                fonteRecurso: this.fonteRecurso,
            }
            this.$emit('salvar', despesaDto)
            this.fecharModal()
        },
    },
}
</script>
